/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AppointmentData from './AppointmentData/index'
import BackToPatientOverlayAction from './BackToPatientOverlayAction/index'
import CloseButtonAction from './CloseButtonAction/index'
import CloseIconAction from './CloseIconAction/index'
import Form from './Form/index'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import MoveIconAction from './MoveIconAction/index'
import PatientPreview from './PatientPreview/index'
import PatientSelect from './PatientSelect/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import TysiaOverlay from 'DesignSystem/TysiaOverlay/index'
import TysiaOverlayContent from 'DesignSystem/TysiaOverlay/TysiaOverlayContent/index'
import TysiaOverlayFooter from 'DesignSystem/TysiaOverlay/TysiaOverlayFooter/index'
import TysiaOverlayHeader from 'DesignSystem/TysiaOverlay/TysiaOverlayHeader/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/AppointmentOverlay/Content",
  isSubmitting
  
}) {
let appointmentOverlayDockedToLeftValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'docked_to_left',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let appointmentOverlayAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_id',
})
let appointmentOverlayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'appointment_overlay',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<AppointmentData
  viewPath={`${viewPath}/AppointmentData`}
/>
<TysiaOverlay
  viewPath={`${viewPath}/TysiaOverlay`}
 left={appointmentOverlayDockedToLeftValueData ? dtSpaceS : "auto"}
 right={appointmentOverlayDockedToLeftValueData ? "auto" : dtSpaceS}
 data="appointment_overlay.docked_to_left"
>
{childProps => (
<React.Fragment>
<TysiaOverlayHeader
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayHeader`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text={appointmentOverlayAppointmentIdValueData ? "Edit appointment" : "New appointment"}
 data="appointment_overlay.appointment_id"
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="orange"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Beta"
/>
)}
</TysiaTag>
</div>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<MoveIconAction
  viewPath={`${viewPath}/MoveIconAction`}
/>
<CloseIconAction
  viewPath={`${viewPath}/CloseIconAction`}
/>
</div>
</React.Fragment>
)}
</TysiaOverlayHeader>
<TysiaOverlayContent
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayContent`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={appointmentOverlayIsSubmittingData}>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 height={60}
 width={60}
 delay={0}
/>
</div>
</fromFlow.When>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pt-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<PatientSelect
  viewPath={`${viewPath}/PatientSelect`}
/>
<PatientPreview
  viewPath={`${viewPath}/PatientPreview`}
/>
<Form
  viewPath={`${viewPath}/Form`}
/>
</div>
</React.Fragment>
)}
</TysiaOverlayContent>
<TysiaOverlayFooter
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayFooter`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<BackToPatientOverlayAction
  viewPath={`${viewPath}/BackToPatientOverlayAction`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
<CloseButtonAction
{...childProps}
  viewPath={`${viewPath}/CloseButtonAction`}
/>
</React.Fragment>
)}
</TysiaOverlayFooter>
</React.Fragment>
)}
</TysiaOverlay>
{children}
</React.Fragment>)
}